import { Button } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { default as UUID } from "node-uuid"
import IScalarForm from "src/libs/scalars/interface/IScalarForm"
import { __ } from "src/libs/utilities"
import { IPETest, PETestQuestion, PETestQuestionAnswer } from "../../data/interfaces"
import { ITestsStore, useTestsStore } from "../../data/store"
import RangeAnswer from "./RangeAnswer"
import useGenTest from "../../hooks/useGenTest"

/* Protopia Ecosystem component */
const Range = (props: IScalarForm): JSX.Element => {
    const {question_id} = useParams()
    const genTest: IPETest = useGenTest()
    const [currentAnswer, setCurrentAnswer] = useState<PETestQuestionAnswer>({} as PETestQuestionAnswer)
    const [answers, setAnswers] = useState<PETestQuestionAnswer[]>([])

    useEffect(() => {
        const question = getQuestion()
        if( !!question ) { 
            // console.log(question)
            if( question.answers?.length === 2 ) {
                setAnswers( question.answers )
            }
            else {
                const _answers: PETestQuestionAnswer[] = [
                    {title: __("Answer") + 1, id: UUID.v4(),}, 
                    {title: __("Answer") + 2, id: UUID.v4(),}
                ] as PETestQuestionAnswer[]
                // console.log( _answers )
                setAnswers( _answers )
                // updateTest( _answers )
            }
            
            if( !!question.answers?.length ) { 
                setCurrentAnswer( question.answers[0] )
            }
            else {
                setAnswers( [] )
                setCurrentAnswer({} as PETestQuestionAnswer)
            }
        }
        else {
            setAnswers( [] )
            setCurrentAnswer({} as PETestQuestionAnswer)
        }
    }, [ question_id ])

    const getQuestion = () => {
        return genTest.questions?.find(q => q.id === question_id) || {} as PETestQuestion
    }
    const onChangeAnswer = (
        value: any, 
        field: string, 
        data: any
    ) => {
        const _answer = {
            ...currentAnswer,
            [field]: value
        }
        const _answers = [
            ...answers.map( a => {
                if(a.id === _answer.id) {
                    return _answer
                }
                return a
            })
        ]
        setCurrentAnswer( _answer )
        setAnswers( _answers )
        updateTest( _answers )
    }
    const updateTest = (_answers: PETestQuestionAnswer[]) => {
        //console.log( genTest ) 
        const _questions = [
            ...genTest?.questions?.map(q => {
                if(q.id === question_id) {
                    const _q =  {
                        ...q,
                        answers: _answers
                    }
                    return _q
                }
                return q
            })
        ]
        //console.log( _questions )
        useTestsStore.setState({
            genTest : {
                ...genTest,
                questions: _questions
            }
        })
    } 
    const onChoose = ( _answer: PETestQuestionAnswer ) => {
        setCurrentAnswer( _answer )
    }
    
    return <div className="my-2 d-flex"> 
        <div className=" w_350 mr-2 pr-2">
            {
                answers.map((a:any, i) => {
                    const isRight = getQuestion()?.right_answer_id === a.id
                    const isCurr  = currentAnswer?.id === a.id
                    return <div className={`d-flex ${ isCurr ? " bg-danger  text-light" : ""}`}  key={ a.id }>
                        <Button 
                            key={a.id} 
                            minimal 
                            alignText="left"
                            icon={ isRight ? "play": "blank" }
                            className="p-1 w-100 m-1 text-overflow flex-grow-100 "
                            onClick={() => onChoose( a ) }
                        >
                            <span className={`${ isRight ? " title" : "" } ${ isCurr ? " text-light" : ""}`}>
                                { a.title }
                            </span>
                        </Button> 
                    </div>
                })
            }
            {/* <Button minimal alignText="left" onClick={onAdd} className="py-1 px-3 w-100">
                <div className="d-flex align-items-center small">
                    <i className="fas fa-plus mr-2" />
                    <span className="descr text-force-contrast">
                        {__("add answer")}
                    </span>
                </div> 
            </Button>  */}
        </div>
        <div className="flex-grow-100 w-100 pl-2">
            <RangeAnswer 
                item={currentAnswer} 
                onChange={onChangeAnswer}  
            />
        </div>
    </div>
}
export default Range